import { R2_PUBLIC_URL } from '@/lib/env'

// Photo rows should hold absolute CDN URLs (workers build them from R2_PUBLIC_URL).
// Rows written while a worker was missing that var hold a bare R2 object key, which
// the browser would resolve against the app origin and render as a broken image.
// Resolve those against the public bucket base so legacy rows still display.
export function resolveAssetUrl(value: string | null | undefined): string | undefined {
  if (!value) return undefined
  if (/^[a-z][a-z0-9+.-]*:/i.test(value)) return value // http(s):, data:, blob:
  const base = R2_PUBLIC_URL?.replace(/\/+$/, '')
  if (!base) return value
  return `${base}/${value.replace(/^\/+/, '')}`
}
